module.exports = "/_next/static/images/060b5a702fb5f9c3f72647940efda9b2-boy-looking-to-the-front-xs@3x.jpg.webp";